module.exports = __webpack_public_path__ + "img/houseImage.98f6e27d.svg";